import "../CSS/project.css";
import { ReactComponent as Back } from "../images/backArrow.svg";
import projects from "./projects/registry";

const Project = ({ index, handleOnClick2 }) => {
  const { Component } = projects[index];
  return (
    <div id="projectCanvas">
      <Back id="goBack" onClick={handleOnClick2} />
      <Component />
    </div>
  );
};
export default Project;
